import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DisplayModes } from '../../../models/enums';
import { Competitor } from '../../../models/lookups/competitor.model';
import { Item } from '../../../models/lookups/item.model';
import { ItemBrand } from '../../../models/lookups/item-brand.model';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { AppTranslationService } from '../../../services/app-translation.service';
import { SettingService } from '../../../settings/components/settings/setting.service';
import { Setting } from '../../../settings/models/setting.model';
import { CompetitorService } from '../competitor.service';
import { ItemService } from '../../item/item.service';
import { ItemBrandService } from '../../item-brand/item-brand.service';

@Component({
  selector: 'crm-add-competitor',
  templateUrl: './add-competitor.component.html',
  styleUrls: ['./add-competitor.component.css']
})
export class AddCompetitorComponent implements OnInit {

  displayMode: DisplayModes = DisplayModes.Success;
  competitor: Competitor = new Competitor();
  visitsByItems: boolean = false;
  items: Item[] = [];
  itemBrands: ItemBrand[] = [];
  selectedItem: Item;
  selectedItemBrand: ItemBrand;

  @Output() closeEvent = new EventEmitter<boolean>();
  @Input() competitorId: number;

  constructor(private readonly competitorService: CompetitorService,
    private readonly itemService: ItemService,
    private readonly itemBrandService: ItemBrandService,
    private readonly settingService: SettingService,
    private readonly translateService: AppTranslationService,
    private readonly alertService: AlertService) { }

  ngOnInit() {
    this.displayMode = DisplayModes.Loading;
    this.settingService.getAllSettings().subscribe(response => {
      let settings = response as Setting[];
      this.visitsByItems = settings.find(x => { return x.key == "visitsByItems"; }).value == 'True';

      if (this.visitsByItems) {
        this.itemService.getAllItemsMiniUnscoped().subscribe(itemsResponse => {
          this.items = itemsResponse as Item[];
          this.loadCompetitorOrReady();
        });
      } else {
        this.itemBrandService.getAll().subscribe(brandsResponse => {
          this.itemBrands = brandsResponse as ItemBrand[];
          this.loadCompetitorOrReady();
        });
      }
    });
  }

  loadCompetitorOrReady() {
    if (this.competitorId != undefined) {
      this.getCompetitor(this.competitorId);
    } else {
      this.displayMode = DisplayModes.Success;
    }
  }

  getCompetitor(competitorId) {
    this.competitorService.getById(competitorId).subscribe(response => {
      this.competitor = response as Competitor;
      if (this.visitsByItems && this.competitor.itemId) {
        this.selectedItem = this.items.find(x => x.id == this.competitor.itemId);
      } else if (!this.visitsByItems && this.competitor.itemBrandId) {
        this.selectedItemBrand = this.itemBrands.find(x => x.id == this.competitor.itemBrandId);
      }
      this.displayMode = DisplayModes.Success;
    },
      err => {
        this.displayMode = DisplayModes.Error;
      });
  }

  save(form) {
    if (!form.invalid) {

      if (this.visitsByItems) {
        this.competitor.itemId = this.selectedItem ? this.selectedItem.id : null;
      } else {
        this.competitor.itemBrandId = this.selectedItemBrand ? this.selectedItemBrand.id : null;
      }

      this.displayMode = DisplayModes.Loading;
      this.alertService.startLoadingMessage("", this.translateService.getTranslation("Saving"));
      this.competitorService.save(this.competitor).subscribe(() => {
        this.alertService.stopLoadingMessage();
        this.displayMode = DisplayModes.Success;
        this.back();
        this.alertService.showMessage("", this.translateService.getTranslation("clm.savedSuccessfully"), MessageSeverity.Success);
      }, () => {
        this.alertService.stopLoadingMessage();
        this.displayMode = DisplayModes.Error;
      });
    }
  }

  back() {
    this.closeEvent.emit(true);
  }

}
